export default "__VITE_ASSET__bnn2ymYy__"